





















import { Component, Vue } from 'vue-property-decorator';

import PrivacyPolicyComponent from '@/components/PrivacyPolicyComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';
import { siteConfig } from '@/SiteConfig.ts';

@Component({
  components: {
    FooterComponent,
    PrivacyPolicyComponent,
  },
})
export default class PrivacyPolicy extends Vue {
  private imgLink = siteConfig.imgLink;
  private title = siteConfig.title;

  private getImgUrl(pic: string) {
    return require('../assets/' + pic);
  }
}
